var map = {
	"./doInject": 381,
	"./doInject.js": 381,
	"./tracking_codes/policystat": 378,
	"./tracking_codes/policystat/": 378,
	"./tracking_codes/policystat/index": 378,
	"./tracking_codes/policystat/index.js": 378,
	"./tracking_codes/pstatbeta": 379,
	"./tracking_codes/pstatbeta/": 379,
	"./tracking_codes/pstatbeta/index": 379,
	"./tracking_codes/pstatbeta/index.js": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 860;